<template>
  <div class="congrats-message">
    <div class="icon-container">
      <font-awesome-icon :icon="icon" class="icon alt fa-5x" />
    </div>
    <div>
      <p class="title is-5">
        {{ message }}
      </p>
    </div>
    <div class="margin-top-20">
      {{ description }}
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
// import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CongratsMessage',
  props: {
    message: {
      type: String,
      default: "Congratulations! You're covered by Pedalsure.",
    },
    description: {
      type: String,
      default: 'Your policy documents have been emailed to you.',
    },
    icon: {
      type: Array,
      default: () => ['fa', 'medal'],
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.remove-bike {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.margin-top-20 {
  margin-top: 20px;
}
.icon {
  // position: absolute;
  top: 50px;
  left: calc(50% - 25px);
  right: 50%;
  height: 60px;
  width: 60px;
  color: $ps-primary;
  margin-bottom: 40px;
}
.title {
  // font-weight: bold;
}
.congrats-message {
  padding: 10px 5%;
  text-align: center;
  @include tablet {
    padding: 10px;
  }
}
.feature-box {
  margin: 10px 0;
  border: 1px solid black;
  border-radius: 5px;
  padding: 20px 10px;
}
</style>
